/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { connect } from 'dva';
import { InfiniteScroll } from 'antd-mobile-v5';
import { openNewWebview, openPageNative } from '@/utils/bridge';
import { reportClick } from '@/utils/report';
import NoMessage from './NoMessage';
import { CONTENT_LINK_TYPE, COVER_WITH_IMAGE_TYPE, MESSAGE_TYPE_MAP } from '../config';
import styles from '../index.less';

const HITSTORY_ENTRY_END_TIME = 1711440996101;

const MessageList = ({ onRead, messageList, hasMore, loadMore, pageName }) => {
  const handleClickMessage = useCallback(
    ({ msgID, contentType, linkURL, coverType, isRead, type }) => {
      // 未读才调用接口
      if (!isRead) onRead({ msgID, type });
      reportClick({
        type,
        page_name: pageName,
        button_name: 'message',
        cover_type: coverType,
        content_type: contentType,
        msg_id: msgID,
      });
      if (contentType === CONTENT_LINK_TYPE) {
        // 跳转链接
        if (linkURL) openPageNative({ url: linkURL });
      } else {
        openPageNative({
          url: `page:web_view?url=${encodeURIComponent(
            `${window.location.origin}/messageCenter/detail/${msgID}`
          )}`,
        });
      }
    },
    [pageName]
  );

  return (
    <div>
      {messageList?.length > 0 ? (
        <div className={styles.messageListWrapper}>
          <div className={styles.messageList}>
            {messageList.map((item, index) => {
              const {
                msgID,
                type,
                title,
                abstract,
                imageURL,
                linkURL,
                effectTime,
                isRead,
                coverType,
                contentType,
              } = item;
              return (
                <div
                  key={index}
                  className={styles.messageItem}
                  onClick={() =>
                    handleClickMessage({ msgID, contentType, linkURL, coverType, isRead, type })
                  }
                >
                  <div className={styles.messageHeader}>
                    <p
                      className={`${styles.category} ${styles[`category-${type}`]} ${
                        isRead ? '' : styles.unread
                      }`}
                    >
                      {MESSAGE_TYPE_MAP[type]}
                    </p>
                    <p className={styles.effectTime}>{effectTime}</p>
                  </div>
                  <div className={styles.messageContent}>
                    <div className={styles.messageText}>
                      <p className={styles.title}>{title}</p>
                      <p className={styles.abstract}>{abstract}</p>
                    </div>
                    {coverType === COVER_WITH_IMAGE_TYPE && (
                      <img className={styles.messageCover} src={imageURL} alt="消息封面" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
          {!hasMore && Date.now() <= HITSTORY_ENTRY_END_TIME && (
            <p
              className={styles.historyEntry}
              onClick={() => openNewWebview({ url: `${window.location.origin}/message` })}
            >
              查看过往公告记录
            </p>
          )}
        </div>
      ) : (
        <NoMessage />
      )}
    </div>
  );
};

export default connect(({ messageCenter, loading }) => ({ messageCenter, loading }))(MessageList);
